import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import {format_money_responsive} from '@bitstillery/common/lib/format'
import {$t} from '@bitstillery/common/app'
import {days_left} from '@bitstillery/common/lib/format'
import m from '@bitstillery/mithril'
import {Icon} from '@bitstillery/common/components'

interface ChangedAttrs {
    className?: string
    current: number
    currency?: string
    collapsed?: boolean
    format_as_number?: boolean
    hint?: boolean
    previous: number
    raise_warning?: boolean
    raise_warning_tip?: string | undefined
    type?: string
    validity?: string | null | undefined
}

export class Changed extends MithrilComponent<ChangedAttrs> {
    format_value(value: number, format_as_number?: boolean, collapsed?: boolean, currency?: string): string {
        if (format_as_number) {
            return value.toString()
        }
        // Default to money formatting when format_as_number is not set
        return format_money_responsive(value, collapsed, collapsed ? undefined : currency)
    }

    view(vnode: m.Vnode<ChangedAttrs>) {
        return (
            <div className={classes('c-changed', vnode.attrs.className, `type-${vnode.attrs.type ? vnode.attrs.type : 'brand'}`)}>
                {vnode.attrs.previous !== vnode.attrs.current && (
                    <span className='previous'>
                        {this.format_value(
                            vnode.attrs.previous,
                            vnode.attrs.format_as_number,
                            vnode.attrs.collapsed,
                            vnode.attrs.currency,
                        )}
                    </span>
                )}
                <span className='current'>
                    <span className='current-value'>
                        {this.format_value(
                            vnode.attrs.current,
                            vnode.attrs.format_as_number,
                            vnode.attrs.collapsed,
                            vnode.attrs.currency,
                        )}
                        {vnode.attrs.hint && <span className='price-hint'>*</span>}
                        {(() => {
                            if (vnode.attrs.validity) {
                                return (
                                    <div className='validity'>
                                        {$t('price.offer_until', {count: days_left(vnode.attrs.validity)})}
                                    </div>
                                )
                            }
                            return undefined
                        })()}
                    </span>
                    {vnode.attrs.raise_warning && (
                        <Icon
                            className='raise-warning'
                            name='arrowUpCircle'
                            size='s'
                            tip={vnode.attrs.raise_warning_tip}
                            type='warning'
                        />
                    )}
                </span>
            </div>
        )
    }
}
